import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminServiceCategoriesStateData } from "@/types/catalog"

export type AdminServiceCategoriesState = {
  data: AdminServiceCategoriesStateData
  error: string | null
}

export const adminServiceCategoriesInitialState: AdminServiceCategoriesState = {
  data: {
    categories: [],
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  error: null,
}

const slice = createSlice({
  name: "adminServiceCategories",
  initialState: adminServiceCategoriesInitialState,
  reducers: {
    setAdminServiceCategoriesAction(
      state,
      { payload }: PayloadAction<AdminServiceCategoriesStateData>,
    ) {
      state.data = payload
      state.error = null
    },
    setAdminServiceCategoriesErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const {
  setAdminServiceCategoriesAction,
  setAdminServiceCategoriesErrorAction,
} = slice.actions
export default slice.reducer
